import { useContactStore } from '../../store/contactStore'
import { CONTACT_STATUSES, STATUS_LABELS } from '../../constants/taxonomy'
import { STATUS_COLORS } from '../map/confidenceStyle'
import type { ContactStatus } from '../../types/contact'

export default function ConfidenceFilter() {
  const { filters, setFilters } = useContactStore()

  return (
    <div className="px-3 py-2">
      <p className="text-xs font-medium text-gray-500 mb-1.5">Minimum confidence</p>
      <div className="flex gap-1.5">
        {CONTACT_STATUSES.map((status: ContactStatus) => {
          const active = filters.min_status === status
          const color = STATUS_COLORS[status]
          return (
            <button
              key={status}
              type="button"
              onClick={() => setFilters({ min_status: status })}
              className={`flex-1 px-1.5 py-1 rounded text-[11px] font-medium border transition-all ${
                active ? 'opacity-100' : 'opacity-40 hover:opacity-70'
              }`}
              style={{
                color,
                borderColor: color + '66',
                backgroundColor: active ? color + '1a' : 'transparent',
              }}
            >
              {STATUS_LABELS[status]}
            </button>
          )
        })}
      </div>
    </div>
  )
}
